<template>
	<div>
		<v-container px-0 pb-0>
			<v-row justify-space-between>
				<v-col>
					<v-card class="pa-2 mr-2" flat min-height="340px" height="100%">
						<Terminals />
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Terminals from "@/components/Terminals";

export default {
	components: {
		Terminals,
	},
	computed: {},
	methods: {},
	mounted() {},
	data: () => ({
		loading: false,
	}),
};
</script>

<style></style>
